export enum UserType  {
    Admin="Admin",
    Seller="Seller",
    Supplier="Supplier",
    Organizer="Organizer",
    User="User",
    Auditor="Auditor"
}
